import React from 'react';

const AI_ICON_GRADIENT_ID = 'ly-ai-icon-gradient';

export const AiIconGradientDefs = () => (
  <svg aria-hidden="true" className="absolute h-0 w-0">
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id={AI_ICON_GRADIENT_ID}
        x1="0"
        x2="18"
        y1="0"
        y2="18">
        <stop offset="0%" stopColor="#1a7a6d" />
        <stop offset="50%" stopColor="#619289" />
        <stop offset="100%" stopColor="#dfb65f" />
      </linearGradient>
    </defs>
  </svg>
);

export const aiIconGradient =
  "[&_path[stroke]]:stroke-[url(#ly-ai-icon-gradient)] [&_[data-stroke='none']]:fill-[url(#ly-ai-icon-gradient)]";
